import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { DialPlansService } from '../../_services/dial-plans.service';
import { DialPlansDetailComponent } from '../dial-plans-detail/dial-plans-detail.component';

@Component({
    selector: 'app-dial-plans-list',
    templateUrl: './dial-plans-list.component.html',
    styleUrls: ['./dial-plans-list.component.css'],
    host: { class: 'list-page' },
    standalone: false
})
export class DialPlansListComponent implements OnInit {
  public dialPlans: any[] = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name')
  };

  constructor(
    public topbarService: TopbarService,
    private dialPlansService: DialPlansService,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.topbarService.setTitle('Planes de llamada');
    this.topbarService.addAction("Nuevo plan", "pi pi-plus", false, () => this.edit(null));
  }

  async loadData($event: any) {
    this.lastGridEvent = $event;
    this.loading = true;

    let params: IParamsCollection = {
      page: { number: $event.first / $event.rows + 1, size: $event.rows },
      sort: ['name'],
    };

    if (typeof $event.sortField != 'undefined') {
      params.sort = [($event.sortOrder > 0 ? '' : '-') + $event.sortField];
    }

    params.filter = FilterBuilder.fromObject(this.filters).build();

    try {
      const response = await firstValueFrom(this.dialPlansService.all(params));
      this.dialPlans = response.data;
      this.totalRecords = response.meta['total'];
      this.topbarService.setCount(this.totalRecords);
    } finally {
      this.loading = false;
    }
  }

  clearFilters() {
    this.filters.name.value = null;
    this.search();
  }

  search() {
    if (!this.lastGridEvent) return;
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(id: any) {
    const ref = this.dialogService.open(DialPlansDetailComponent, {
      closable: true,
      modal: true,
      data: { id: id ? id : null },
      header: id ? 'Detalle del plan de llamada' : 'Nuevo plan de llamada',
      width: '90vw'
    });
    ref.onClose.subscribe(() => {
      this.loadData(this.lastGridEvent);
    });
  }

  delete(dialPlan: any) {
    this.confirmationService.confirm({
      message: '¿Está seguro que desea eliminar el plan "' + dialPlan.name + '"?',
      header: 'Eliminar plan',
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar',
      acceptButtonStyleClass: 'p-button-danger',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.dialPlansService.delete(dialPlan.id).subscribe({
          next: () => {
            this.messageService.add({ closable: true, severity: 'success', detail: 'Plan eliminado correctamente' });
            this.loadData(this.lastGridEvent);
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error?.error?.errors?.[0]?.title || error?.error?.title || 'No se puede eliminar el plan. Puede estar referenciado por otro plan.' });
          }
        });
      }
    });
  }
}
